export const email = "info@dafrancostuttgart.de"
export const telephone = "+49711294744"
export const telephoneDisplay = "0711/294744"
export const uiBreakpointMobile = "48em" // keep in sync with scss/_vars
